import { LeaseStatusBase } from './base/lease-status-base';

export class LeaseStatus extends LeaseStatusBase { }